import { Link } from "react-router-dom";
import { usecases } from "../../data";

const Usecases = () => {
  return (
    <div className="grid grid-cols-3 gap-6 sm:grid-cols-2 mobile:grid-cols-1 px-10 mobile:hidden">
      {usecases.map((data, key) => (
        <Link
          className="relative hover:transform hover:transition hover:-translate-y-1 hover:-translate-x-1 hover:duration-700 hover:ease-in-out hover:border-2 border-gray-500 max-w-md h-96 border-0 rounded-xl backdrop-blur-3xl bg-black-nblack backdrop-filter py-14 px-5  cursor-pointer"
          key={key}
          to={`/usecase/${data.tag}`}
        >
          <h3 className="font-normal text-white text-1xl leading-9 font-poppins mb-5 w-60 px-2">
            {data.heading}
          </h3>
          <ul className="list-disc px-5">
            {data.desc.map((item, key) => (
              <li
                key={key}
                className="font-normal text-gray-lgray text-base
                 font-mulish max-w-xs leading-7"
              >
                {item.link}
              </li>
            ))}
          </ul>
          <p className="text-green font-poppins font-normal text-base absolute bottom-0 mb-4">
            Read More
          </p>
        </Link>
      ))}
    </div>
  );
};

export default Usecases;
